module.exports = __webpack_public_path__ + "static/media/firmness.5cd9cb9b.svg";